import { render } from "./CardPerson.vue?vue&type=template&id=11b6a5a0&scoped=true"
import script from "./CardPerson.vue?vue&type=script&lang=js"
export * from "./CardPerson.vue?vue&type=script&lang=js"

import "./CardPerson.vue?vue&type=style&index=0&id=11b6a5a0&scoped=true&lang=css"

import exportComponent from "/mnt/dados/Projects/uparte_dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11b6a5a0"]])

export default __exports__